module.exports = __webpack_public_path__ + "20524c3fc1b761604a76a670781c19d3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ranks/school-comp-medal-2-basic.png
// module id = 3396
// module chunks = 0